import React, { useState, useEffect, useRef } from "react";

const SplashScreen = ({ onFinish }) => {
  const [fade, setFade] = useState(false);
  const videoRef = useRef(null);

  useEffect(() => {
    // Inicia o vídeo assim que o componente é montado
    if (videoRef.current) {
      videoRef.current.play().catch(error => {
        console.error("Erro ao reproduzir vídeo:", error);
      });
    }

    // Configura os timeouts para o fade-out e remoção
    const fadeTimeout = setTimeout(() => setFade(true), 800); // Inicia fade-out após 2.5s
    const finishTimeout = setTimeout(onFinish, 1600); // Remove o splash após 3s

    // Limpa os timeouts se o componente for desmontado antes
    return () => {
      clearTimeout(fadeTimeout);
      clearTimeout(finishTimeout);
    };
  }, [onFinish]);

  return (
    <div className={`splash-screen ${fade ? "fade-out" : ""}`}>
      {/* <img src="/img/splashScreen.png" alt="AVEX" /> */}
      <video 
        ref={videoRef}
        src="/video/splashScreen.mp4" 
        alt="AVEX"
        muted // Muitos navegadores exigem muted para autoplay
        playsInline // Necessário para alguns navegadores mobile
        // autoPlay // Tenta autoplay, mas pode ser bloqueado sem muted
        loop={false}
      />
    </div>
  );
};

export default SplashScreen;
